import { render, staticRenderFns } from "./vehicleAccidentList.vue?vue&type=template&id=49f427e5"
import script from "./vehicleAccidentList.vue?vue&type=script&lang=js"
export * from "./vehicleAccidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports